import { PropsWithChildren, useEffect, useRef } from "react";

import { Flex, FlexProps } from "@radix-ui/themes";
import { styled } from "@stitches/react";
type Props = PropsWithChildren<{
  visible: boolean;
  contained?: boolean;
}> &
  FlexProps;

const RowActionsContainer = styled(Flex, {
  height: "100%",
  position: "absolute",
  right: "100%",
  transform: "translateY(-50%)",
  padding: "0px var(--table-cell-padding)",
  transition: "opacity 0.2s linear",
  alignItems: "center",
  "> button": {
    marginLeft: "1px",
  },
  variants: {
    visible: {
      true: {
        opacity: 1,
      },
      false: {
        opacity: 0,
      },
    },
    contained: {
      true: {
        position: "relative",
        height: "unset",
        right: "unset",
        transform: "unset",
        padding: "0",
      },
    },
  },
});

export const RowActions = ({
  visible,
  contained,
  children,
  ...flexProps
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contained) return;
    if (ref.current) {
      const parentEl = ref.current.parentElement;
      if (!parentEl) return;
      ref.current.style.height = parentEl.clientHeight + "px";
    }
  }, [contained]);

  return (
    <RowActionsContainer
      ref={ref}
      direction="row"
      gap="1"
      visible={visible}
      contained={contained}
      {...flexProps}
    >
      {children}
    </RowActionsContainer>
  );
};
